import { render, staticRenderFns } from "./formbuilderRepeatableTemplatePreview.vue?vue&type=template&id=984efa2a&scoped=true"
import script from "./formbuilderRepeatableTemplatePreview.vue?vue&type=script&lang=js"
export * from "./formbuilderRepeatableTemplatePreview.vue?vue&type=script&lang=js"
import style0 from "./formbuilderRepeatableTemplatePreview.vue?vue&type=style&index=0&id=984efa2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "984efa2a",
  null
  
)

export default component.exports